/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchGetMerchantUnitOvertimeRuleset} from '../api'

export const useMutationBatchGetMerchantUnitOvertimeRuleset = createReactQueryMutationHook('batchGetMerchantUnitOvertimeRuleset', batchGetMerchantUnitOvertimeRuleset)
